import state from "./moduleMailDraftStates";
import mutations from "./moduleMailDraftMutations";
import actions from "./moduleMailDraftActions";
import getters from "./moduleMailDraftGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}